import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_PROFILES_SEARCH_RESULTS = gql`
  query GetProfilesSearchResults ($search: String!) {
    profiles(search: $search) {
      numResults
      profiles {
        id
        uuid
        name
        profileType {
          id
          name
        }
        benefits {
          name
        }
        picture {
          ...imageFields
        }
        jobs {
          name
          id
          interestFields {
            id
          }
        }
        address {
          addressLatLon {
            lat
            lon
          }
          street
          addressCity {
            name
            addressDistrict {
              name
            }
          }
        }
        hasStory
        quizDone
      }
    }
  }
  ${ImageFragment}
`;
